module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/high-capacity-transport.1a01a850.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/high-capacity-transport.png
// module id = 3739
// module chunks = 11